export default class ContactBlock {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    var mailLinks = this.el.querySelectorAll(".js-contactblock-mailto");
    mailLinks.forEach((mailLink) => {
      this.initializeMailLink(mailLink);
    });
  }

  initializeMailLink(mailLink) {
    var encodedMailUser = mailLink.getAttribute("data-mail-user");
    var encodedMailDomain = mailLink.getAttribute("data-mail-domain");

    var mailUser = this.decodeBase64(encodedMailUser);
    var mailDomain = this.decodeBase64(encodedMailDomain);

    if (!mailUser || !mailDomain || mailUser.includes("@") || mailDomain.includes("@")) {
      this.disableMailLink(mailLink);
      return;
    }

    var email = `${mailUser.trim()}@${mailDomain.trim()}`;
    if (!this.isValidEmail(email)) {
      this.disableMailLink(mailLink);
      return;
    }

    mailLink.setAttribute("href", `mailto:${email}`);
    mailLink.removeAttribute("aria-disabled");
  }

  decodeBase64(value) {
    if (!value) {
      return null;
    }

    try {
      var decoded = window.atob(value);
      var encodedUtf8 = decoded
        .split("")
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, "0")}`)
        .join("");

      return decodeURIComponent(encodedUtf8);
    } catch (error) {
      try {
        return window.atob(value);
      } catch (fallbackError) {
        return null;
      }
    }
  }

  isValidEmail(value) {
    if (!value) {
      return false;
    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  disableMailLink(mailLink) {
    mailLink.removeAttribute("href");
    mailLink.setAttribute("aria-disabled", "true");

    if (mailLink.dataset.mailDisabled !== "true") {
      mailLink.addEventListener("click", (event) => event.preventDefault());
      mailLink.dataset.mailDisabled = "true";
    }
  }
}
